import React from 'react';
import { t } from 'Src/i18n';
import { OneyLabel } from './OneyLabel';
type Props = {
  price: {
    total: Price;
  };
  iconClassname: string;
};
export const OneyFromPricing = ({ price, iconClassname }: Props) => {
  return (
    <div className="flex items-start justify-start gap-4 text-12 md:items-center md:justify-center">
      <OneyLabel
        price={price}
        iconClassname={iconClassname}
        payingLabel={t('booking.banking.paymentSchedule.fromPricing')}
      />
    </div>
  );
};
